import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle2 } from 'lucide-react';
type Sale = {
  name: string;
  city: string;
  product: string;
  minutesAgo: number;
};
const NAMES = ['Martín G.', 'Lucía P.', 'Diego R.', 'Valentina S.', 'Andrés M.', 'Camila F.', 'Sebastián L.', 'Florencia B.', 'Rodrigo C.', 'Sofía A.'];
const CITIES = ['Montevideo', 'Canelones', 'Maldonado', 'Salto', 'Paysandú', 'Rivera', 'Tacuarembó', 'Las Piedras', 'Ciudad de la Costa'];
const PRODUCTS = ['Megapack Básico', 'Megapack + Contenido Extra'];
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function generateSale(): Sale {
  return {
    name: pick(NAMES),
    city: pick(CITIES),
    product: pick(PRODUCTS),
    minutesAgo: Math.floor(Math.random() * 12) + 1
  };
}
export function SaleNotifications() {
  const [sale, setSale] = useState<Sale | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: ReturnType<typeof setTimeout>;
    let hideId: ReturnType<typeof setTimeout>;
    const show = () => {
      setSale(generateSale());
      hideId = setTimeout(() => {
        setSale(null);
        timeoutId = setTimeout(show, 6000 + Math.random() * 4000);
      }, 5500);
    };
    timeoutId = setTimeout(show, 4000);
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(hideId);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <div className="fixed bottom-24 md:bottom-6 left-4 right-4 md:left-6 md:right-auto z-40 pointer-events-none" data-id="element-256">
      <AnimatePresence mode="wait" data-id="element-257">
        {sale && <motion.div key={`${sale.name}-${sale.city}-${sale.minutesAgo}`} initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto relative max-w-sm md:max-w-md bg-white border border-brand-light/40 rounded-2xl shadow-xl shadow-brand-dark/10 pl-4 pr-3 py-3 flex items-center gap-3 overflow-hidden" role="status" aria-live="polite" data-id="element-258">
            {/* Left accent bar */}
            <span className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-brand-light to-brand-green" data-id="element-259" />

            {/* Avatar */}
            <div className="flex-shrink-0 relative w-11 h-11 rounded-full bg-gradient-to-br from-brand-light to-brand-green flex items-center justify-center shadow-sm" data-id="element-260">
              <ShoppingBag className="w-5 h-5 text-white" data-id="element-261" />
              {/* Live pulse dot */}
              <span className="absolute -top-0.5 -right-0.5 flex h-3 w-3" data-id="element-262">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-leaf opacity-75" data-id="element-263" />
                <span className="relative inline-flex rounded-full h-3 w-3 bg-brand-green border-2 border-white" data-id="element-264" />
              </span>
            </div>

            <div className="flex-1 min-w-0" data-id="element-265">
              <p className="text-sm font-bold text-slate-dark leading-tight" data-id="element-266">
                {sale.name}{' '}
                <span className="font-medium text-slate-light" data-id="element-267">
                  · {sale.city}
                </span>
              </p>
              <p className="text-xs text-slate mt-0.5 truncate" data-id="element-268">
                acaba de acceder al{' '}
                <span className="font-semibold text-brand-green" data-id="element-269">
                  {sale.product}
                </span>
              </p>
              <div className="inline-flex items-center gap-1 mt-1.5 bg-brand-green/10 text-brand-green text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full" data-id="element-270">
                <CheckCircle2 className="w-3 h-3" data-id="element-271" />
                <span data-id="element-272">Verificada · hace {sale.minutesAgo} min</span>
              </div>
            </div>

            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="flex-shrink-0 self-start text-slate-light hover:text-slate-dark transition-colors p-1 -m-1" data-id="element-273">
              <X className="w-4 h-4" data-id="element-274" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}